import type { IconData } from '@stacksjs/iconify-core'

export const otherUiSparks: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12.5 0h1A2.5 2.5 0 0 0 16 2.5v1A2.5 2.5 0 0 0 13.5 6h-1A2.5 2.5 0 0 0 10 3.5v-1A2.5 2.5 0 0 0 12.5 0m-7 3h2A5.5 5.5 0 0 0 13 8.5v2A5.5 5.5 0 0 0 7.5 16h-2A5.5 5.5 0 0 0 0 10.5v-2A5.5 5.5 0 0 0 5.5 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiSparks
